import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    gridContainer: {
      display: "flex",
      flex: "1 1 100%",
      flexWrap: "wrap",
      gap: "24px",
      marginTop: "24px",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
        flexDirection: "column",
      },
    },
    switcherBox: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column-reverse",
        gap: "18px",
        justifyContent: "center",
      },
    },
  };
});
